// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightMiniReport-cls1_Eal","cls2":"CiterightMiniReport-cls2_uDt CiterightMiniReport-cls1_Eal"};